import { IconButton } from "../../../components";
import { StandardTableSortablePropertyHeader } from "../../../components/tables/StandardTable";

const StandardParagraphTableHeader = ({ currentSort, sortTable, showCreateModal }) => {
    const Header = ({ property, children }) => <StandardTableSortablePropertyHeader sort={currentSort} sortTable={sortTable} property={property}>{children}</StandardTableSortablePropertyHeader>

    return <thead>
        <tr>
            <Header property={'name'}>Name</Header>
            <Header property={'createdDate'}>Created</Header>
            <Header property={'openedDate'}>Opened</Header>
            <Header property={'publishedDate'}>Published</Header>
            <th className="sticky-header"><IconButton icon="plus" variant="success" onClick={showCreateModal} /></th>
        </tr>
    </thead>
}

export default StandardParagraphTableHeader;